import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { BootsrapModel } from "../../types/BootsrapModel";
import type { CountryModel } from "../../types/CountryModel";
import type { CurrencyModel } from "../../types/CurrencyModel";
import type { PaymentSystemModel } from "../../types/PaymentSystemModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.SYSTEM_DATA}`;

export interface Values {
	loading: boolean;

	bootstrap?: BootsrapModel;
	currencies: CurrencyModel[];
	countries: CountryModel[];
	paymentSystems: PaymentSystemModel[];

	authDialog?: {
		open: boolean;
		flow?: "bonus" | "login" | "signUp";
		next?: null | string;
	};
}

export const initialState: IStateProps<Values> = {
	loading: false,

	bootstrap: undefined,
	currencies: [],
	countries: [],
	paymentSystems: [],

	authDialog: undefined
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
